import axios from "axios";

export const contactAPI = axios.create({
  baseURL: "/api/contact/",
});
